import { useTranslation } from "react-i18next"
import { CanSendAbsenceRequest } from "app/PermissionChecker"
import HomeWidgetLayout from "components/layout/HomeWidgetLayout"
import NewAbsenceRequestModal from "../components/NewAbsenceRequestModal"
import { useGetMyWorkerContractQuery } from "features/hr/workContract/api/workContractApiSlice"
import WarningMessage from "components/commons/WarningMessage"

function SendAbsenceRequestWidget() {

    const [t, i18n] = useTranslation(["absenceReport"])

    const {
        data: workerContract,
        isSuccess,
        isError: noActiveWorkContract
    } = useGetMyWorkerContractQuery()

    return <HomeWidgetLayout
        title={t("absenceReport:module.short_name")}
        permission={CanSendAbsenceRequest}
        content={
            noActiveWorkContract ?
                <WarningMessage message="Non è possibile inviare richieste di assenza senza un contratto assegnato." />
                :
                <> <p className="text-muted"><i className="fa-solid fa-file-import fa-2xl"></i></p>
                    <p>{t("absenceReport:helper.send_new_request")}</p>
                    <NewAbsenceRequestModal />
                </>

        }
    />
}

export default SendAbsenceRequestWidget